import React from 'react';
import { Link } from 'react-router-dom';
import { HomeIcon } from '@heroicons/react/24/outline';

const NotFound = () => {
  return (
    <div className="text-center py-16">
      <h1 className="text-4xl font-bold text-gray-900 mb-4">404 Not Found</h1>
      <p className="text-gray-600 mb-8">
        The page you are looking for does not exist or has been moved.
      </p>
      <Link
        to="/"
        className="btn-primary inline-flex items-center"
      >
        <HomeIcon className="h-5 w-5 mr-2" />
        Return to Dashboard
      </Link>
    </div>
  );
};

export default NotFound;